module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-12.abdbbb68.png";